import { createContext, useContext } from "react";
export const DEFAULT_LAYOUT_GRID_SETTINGS = {
    gridMode: "FlexboxGrid",
    flexLayoutBreakpoint: "sm",
};
export const LayoutGridSettingsContext = createContext(DEFAULT_LAYOUT_GRID_SETTINGS);
LayoutGridSettingsContext.displayName = "LayoutGridSettingsContext";
export function useLayoutGridSettingsContext() {
    return useContext(LayoutGridSettingsContext);
}
/**
 * Legacy alias for {@link useLayoutGridSettingsContext}
 * @deprecated Use {@link useLayoutGridSettingsContext} instead
 */
export const useLayoutComponentContext = useLayoutGridSettingsContext;
//# sourceMappingURL=LayoutGridSettingsContext.js.map